import DuckEntity from './DuckEntity'

const entity = new DuckEntity('fields');

/**
 * Returns a map that indexes all fields by name.
 *
 * @param {object} state - redux state
 * @param {string} stateKey - redux state key (defaults to "_all")
 * @returns {Map} - map of fields by name
 */
entity.allByName = (state, stateKey = '_all') => {
  const fields = entity.all(state, stateKey);
  const byName = new Map(fields.map(field => [field.name, field]));

  // Copy loading state from fields
  byName.ready = fields.ready;
  byName.pending = fields.pending;
  byName.error = fields.error;
  return byName;
};

const reducer = entity.reducer;
export {reducer as default, entity};
